<ul class="hvac-marketing-incentives hvac-page-section">
    <li class="hvac-marketing-incentive" *ngFor="let incentive of data?.Content?.list.$values">
        <utc-check-list-item [item]="incentive"></utc-check-list-item>
    </li>
</ul>
<hvac-link class="hvac-check-list-cta" [linkType]="linkType" [link]="data?.Content?.links">{{ data?.Content?.links.linkText }}</hvac-link>
